export default __webpack_public_path__ + "static/brand-promo-video-poster-8ed60018265af9256e0026160d3d1f16.jpg";